import axios, { AxiosInstance } from 'axios'

export class BaseApi {
  static m_instance: any

  private m_axiosInstance: AxiosInstance

  private constructor() {
    this.m_axiosInstance = axios.create({
      baseURL: 'https://api.photos-presse.com'
    })
  }

  public static get instance(): BaseApi {
    if (!BaseApi.m_instance) {
        BaseApi.m_instance = new BaseApi()
    }

    return BaseApi.m_instance
  }

  public getAxiosInstance(): AxiosInstance { return this.m_axiosInstance; }
}
